import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Stack, Alert, Button } from "@mui/material";
import lovStore from "../../../stores/LovStore";
import { Lov } from "../../../stores/LovStore/LovStore";
import "./CategoriesManagement.scss";

const CategoriesManagement = () => {
  const [textareaValue, setTextareaValue] = useState("");
  const [lov, setLov] = useState<Lov | null>();
  const [loading, setLoading] = useState(false);
  const [jsonError, setJsonError] = useState<string | null>(null);
  const hasChanges = JSON.stringify(lov?.value, null, 2) !== textareaValue;

  useEffect(() => {
    setLoading(true);
    lovStore
      .fetchLovByCode(`case-categories-all`, `case-categories`, false)
      .then((data) => {
        if (data?.value && Object.keys(data?.value || {}).length > 0) {
          setTextareaValue(JSON.stringify(data.value, null, 2));
        } else {
          setTextareaValue("{}");
        }
        setLov(data);
        setJsonError(null);
      })
      .finally(() =>
        setTimeout(() => {
          setLoading(false);
        }, 500)
      );
  }, []);

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setTextareaValue(value);
    try {
      JSON.parse(value);
      setJsonError(null);
    } catch (err: any) {
      setJsonError("FORMAT HATASI: " + err.message);
    }
  };

  const handleSubmit = () => {
    if (!lov) {
      return;
    }

    const data = { ...lov, value: JSON.parse(textareaValue) };

    setLoading(true);
    lovStore.updateLov(lov.id, data).finally(() => {
      setLov(data);
      setLoading(false);
    });
  };

  return (
    <div className="container admin-container category-management">
      {loading ? (
        <Stack
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          className={"pt pb"}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <Box sx={{ mt: 2 }}>
          {jsonError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {jsonError}
            </Alert>
          )}
          <textarea
            rows={40}
            style={{ width: "100%" }}
            value={textareaValue}
            onChange={handleTextareaChange}
          />
          <div className="mt">
            <Button
              fullWidth
              variant="outlined"
              disabled={!textareaValue || !hasChanges || !!jsonError || loading}
              onClick={handleSubmit}
            >
              Kaydet
            </Button>
          </div>
        </Box>
      )}
    </div>
  );
};

export default CategoriesManagement;
